import { ImageAsset } from "@/components/ImageAsset";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Link from "next/link";

export const BandIndexLinkCard = ({ label, link, image }) => {
  return (
    <ButtonBase component={Link} href={link} sx={imageStyles}>
      <Grid
        container
        justifyContent="center"
        alignItems="flex-end"
        sx={{ height: "100%" }}
      >
        <Grid item xs={12}>
          <Button fullWidth variant="outlined-white">
            {label}
          </Button>
        </Grid>
      </Grid>
      <Box className="image-gradient"></Box>
      {image && <ImageAsset url={image} layout="fill" />}
    </ButtonBase>
  );
};

const imageStyles = {
  width: "100%",
  position: "relative",
  aspectRatio: "16 / 9",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "1.5rem",
  "& .MuiButton-root": {
    zIndex: "100",
  },
  "& .image-gradient": {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: "50",
    background:
      "linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.1) 100%), linear-gradient(0deg, rgba(126,105,238,0.86) 0%, rgba(126,105,238,0.86) 100%)",
  },
  "&:hover": {
    "& .image-gradient": {
      background:
        "linear-gradient(0deg, rgba(0,0,0,0.46) 0%, rgba(0,0,0,0) 100%), linear-gradient(0deg, rgba(244,156,46,0.86) 0%, rgba(244,156,46,0.86) 100%)",
    },
  },
};
